/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Field_CityInputs */

const en_reference_field_city = /** @type {(inputs: Reference_Field_CityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`City`)
};

/**
* | output |
* | --- |
* | "City" |
*
* @param {Reference_Field_CityInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_field_city = /** @type {((inputs?: Reference_Field_CityInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Field_CityInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_field_city(inputs)
});